import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { getArticle } from "../../app/api";
import { Text } from "../../ui-kit/Text/Text";
import { Header } from "../../ui-kit/Header/Header"
import { Breadcrumbs } from "../../ui-kit/Breadcrumbs/Breadcrumbs";

import styles from "./Article.module.scss";


export const Article = () => {

  const BASE_URL = process.env.NODE_ENV === 'production' 
                      ? process.env.REACT_APP_BASE_URL_PROD 
                      : process.env.REACT_APP_BASE_URL_DEV;
  const {id} = useParams();
  const [article, setArticle] = useState(null);
  const [breadLinks, setBreadLinks] = useState(null)

  useEffect(() => {
    async function loadArticle(id) {
      //console.log('Вызов функции loadArticles');
      try {
        const data = await getArticle(id);
        // console.log('Статья загружена с сервера: ', data)
        setArticle(data);
        setBreadLinks([
          {href: '/articles', title: "Статьи"},
          {herf: '#', title: data.title}
        ]);

      } catch (e) {
        console.error("Ошибка при загрузке статьи: ", e);
      }
    };

    loadArticle(id);
  }, []);



  return (
    article && (<div>
      {breadLinks && (<Breadcrumbs links={breadLinks} />)}

      <Header header>{article.title}</Header>

      <div className={styles.article_mainImage}>
        <img src={BASE_URL  + article.main_image.meta.download_url} />
      </div>

      <Text
        className={styles.article_paragraph}
        light
        style={{textAlign: "right"}}
      >
        {/* {article.meta.first_published_at.slice(8,10)}.{article.meta.first_published_at.slice(5,7)}.{article.meta.first_published_at.slice(0,4)} */}
      </Text>

      {article.body.map((el) => {
        if (el.type === 'paragraph'){
          return(
            <Text key={el.id} className={styles.article_paragraph} light
              dangerouslySetInnerHTML={{ __html: el.value }} />
          )
        }

        if (el.type === "quote") {
          return(
            <div key={el.id} className={styles.article_quote}>
              <Text light italic
                dangerouslySetInnerHTML={{ __html: el.value }} />
            </div>
          )
        }

        if (el.type === "heading") {
          return(
              <Header key={el.id} title
                dangerouslySetInnerHTML={{ __html: el.value }} />
          )
        }

        if (el.type === "image") {
          return(
            <div key={el.id} className={styles.article_imageBlock}>
              <img src={el.value} className={styles.article_imageBlock_img}/>
            </div>
          )
        }

      })}

      <Text
        className={styles.article_paragraph}
        light
        style={{textAlign: "right"}}
      >
        {article.meta.first_published_at.slice(8,10)}.{article.meta.first_published_at.slice(5,7)}.{article.meta.first_published_at.slice(0,4)}
      </Text>

    </div>)
  );
};
